import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const PRODUCTS = [
  { id: 1, name: "Agricultural Grains", cat: "export", tag: "Rice • Wheat • Pulses", img: "https://images.unsplash.com/photo-1705475388190-775066fd69a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { id: 2, name: "Spices & Herbs", cat: "export", tag: "Turmeric • Chilli • Cumin", img: "https://images.unsplash.com/photo-1716816211590-c15a328a5ff0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { id: 3, name: "Raw Materials", cat: "export", tag: "Minerals • Textiles • Ore", img: "https://images.unsplash.com/photo-1546702005-7f8e5aeab4a6?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { id: 4, name: "Industrial Machinery", cat: "import", tag: "Equipment • Components", img: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { id: 5, name: "Electronics & Tech", cat: "import", tag: "Devices • Semiconductors", img: "https://images.unsplash.com/photo-1518770660439-4636190af475?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { id: 6, name: "On-Demand Sourcing", cat: "export", tag: "Bespoke • Any Commodity", img: "https://images.unsplash.com/photo-1565891741441-64926e441838?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
];

const TABS = [
  { id: "all", label: "All Trade", testId: "product-tab-all" },
  { id: "export", label: "Exports", testId: "product-tab-exports" },
  { id: "import", label: "Imports", testId: "product-tab-imports" },
];

export default function Products() {
  const [tab, setTab] = useState("all");
  const filtered = PRODUCTS.filter((p) => tab === "all" || p.cat === tab);

  return (
    <section id="products" className="relative border-y border-white/10 bg-[#0E1626] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-12 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="data-label">03 — What We Trade</span>
            <h2 className="mt-3 font-display text-3xl font-bold uppercase tracking-tight text-white sm:text-4xl lg:text-5xl">
              Sourced in India.<br /><span className="text-[#D4AF37]">Trusted worldwide.</span>
            </h2>
          </div>
          <div className="flex gap-2">
            {TABS.map((t) => (
              <button
                key={t.id}
                data-testid={t.testId}
                onClick={() => setTab(t.id)}
                className={`rounded-full px-5 py-2.5 text-sm font-semibold transition-all duration-300 ${tab === t.id ? "bg-[#E65100] text-white" : "border border-white/15 text-slate-300 hover:border-[#E65100]"}`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <motion.div layout className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <AnimatePresence mode="popLayout">
            {filtered.map((p) => (
              <motion.article
                key={p.id}
                layout
                data-testid={`product-card-${p.id}`}
                initial={{ opacity: 0, scale: 0.94 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.94 }}
                transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                className="hover-lift group relative aspect-[4/5] overflow-hidden rounded-2xl border border-white/10"
              >
                <img src={p.img} alt={p.name} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 brightness-110 contrast-105 group-hover:scale-110 group-hover:brightness-125" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1320] via-transparent to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-90" />
                <div className="absolute left-4 top-4">
                  <span className={`rounded-full px-3 py-1 text-[0.65rem] font-bold uppercase tracking-wider shadow-lg ${p.cat === "export" ? "bg-[#E65100] text-white" : "bg-[#D4AF37] text-[#0B1320]"}`}>
                    {p.cat}
                  </span>
                </div>
                <div className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-[#0B1320] via-[#0B1320]/80 to-transparent">
                  <p className="data-label mb-1 text-[#FFD700]">{p.tag}</p>
                  <div className="flex items-center justify-between">
                    <h3 className="font-display text-xl font-bold text-white drop-shadow">{p.name}</h3>
                    <ArrowUpRight className="h-5 w-5 text-[#FFD700] opacity-80 transition-all duration-300 group-hover:opacity-100 group-hover:scale-110" />
                  </div>
                </div>
              </motion.article>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
}
